import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Turnstile } from '@marsidev/react-turnstile';

const TurnstileWidget = forwardRef(({ onSuccess, onError, onExpire }, ref) => {
  const turnstileRef = useRef(null);

  useImperativeHandle(ref, () => ({
    reset: () => {
      turnstileRef.current?.reset();
    },
  }));

  return (
    <div className="flex justify-center">
      <Turnstile
        ref={turnstileRef}
        siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
        onSuccess={onSuccess}
        onError={() => onError?.()}
        onExpire={() => onExpire?.()}
        options={{
          theme: 'light',
          size: 'flexible',
        }}
      />
    </div>
  );
});

TurnstileWidget.displayName = 'TurnstileWidget';

export default TurnstileWidget;
